/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { CableTraySizeTagModule } from './cable-tray-size-tag.module';
export { CableTraySizeTagComponent } from './cable-tray-size-tag.component';